import { Component, Input, HostBinding, DoCheck, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { translationObject } from '../../../../../constants';
import { Subscription, of } from 'rxjs';

@Component({
  selector: 'app-form-field-error',
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss']
})
export class FormFieldErrorComponent implements DoCheck {
  @Input() control: UntypedFormControl;
  errors: string[];
  @HostBinding('class.hidden') isHidden = false;
  translationKeyPrefix = 'FORM_FIELD_VALIDATION';
  /** Stores the current translations used to populate this view. */
  localTranslations = translationObject.currentTranslation;
  /** Subscribes to the current global translation object. */
  translationSubscription: Subscription;

  /**
   * Standard Angular Constructor.
   *
   * @ignore
   */
  constructor(
    /* eslint-disable */
    private translateService: TranslateService,
    private changeRef: ChangeDetectorRef
    /* eslint-enable */
  ) {}

  /**
   * A callback method that performs change-detection, invoked
   * after the default change-detector runs.
   * See `KeyValueDiffers` and `IterableDiffers` for implementing
   * custom change checking for collections.
   */
  ngDoCheck() {
    this.isHidden = !(this.control && this.control.invalid && this.control.touched);
    const keys = Object.keys(this.control.errors || {}).map((key: string) => {
      return `${this.translationKeyPrefix}.${key.toUpperCase()}`;
    });
    this.errors = [];
    if (keys.length === 0) {
      return;
    }
    let translationData  = {};
    Object.keys(this.control.errors || {}).forEach((key: string) => {
      const error = this.control.errors[key];
      if (typeof error === 'object') {
        translationData = {
          ...translationData,
          ...error
        };
      }
    });

    this.translationSubscription = of(translationObject.currentTranslation).subscribe((translations: any) => {
      this.localTranslations = translations;
      if (this.localTranslations) {
        this.errors.push(this.localTranslations.PAGES.FORM_FIELD_VALIDATION.REQUIRED);
        this.changeRef.detectChanges();
      } else {
        this.translateService.get(keys, translationData).subscribe((data: any) => {
          this.errors = [];
          for (let [key, value] of Object.entries(data)) {
            // ngx-translate's get() method does not throw an error when a translation isn't found
            // but rather sets value = key.
            if (key === value) {
              // TODO Replace console.error with call to Logger Service
              console.error(`Translation entry missing for ${this.translationKeyPrefix}.${key}`);
              value = key.replace(this.translationKeyPrefix, '');
            }
            this.errors.push(value as string);
          }
        });
      }
    });
  }

  /**
   * Finds and returns the root form control of the given control.
   *
   * @arg {AbstractControl} control The control to get the root from.
   * @return {AbstractControl} The root form control.
   */
  getRootFormControl(control: AbstractControl): AbstractControl {
    if (control.parent) {
      return this.getRootFormControl(control.parent);
    } else {
      return control;
    }
  }
}
